import styled from 'styled-components';

export const Wrapper = styled.div`
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  background: #93c051, 100%;
  background: linear-gradient(0deg, #74c300 0%, #93c051 75%);
`;

export const Content = styled.div`
  width: 100%;
  max-width: 501px;
  text-align: center;
`;
